var _style, _ellipse, _g, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataupdate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 72",
    style: {
      enableBackground: "new 0 0 72 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;fill:#E1FFF6;}\n\t.st1{fill:#10B981;}\n\t.st2{fill:none;stroke:#10B981;stroke-width:2;stroke-miterlimit:10;}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 36,
    cy: 36,
    rx: 35.5,
    ry: 35.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.9,46.6l-1.3,1.3c-1.3-0.8-2.8-1.3-4.3-1.5s-3.1,0.1-4.4,0.8c-1.3,0.7-2.5,1.6-3.5,2.9 c-0.9,1.2-1.5,2.7-1.6,4.3c0,0.1,0,0.3,0,0.4s0.1,0.3,0.1,0.3c0.1,0.1,0.1,0.1,0.3,0.3c0.1,0,0.3,0.1,0.4,0.1h1.7 c0.3,0,0.4-0.1,0.5-0.3c0.1-0.1,0.3-0.3,0.3-0.5c0.1-0.8,0.4-1.7,0.9-2.4s1.2-1.3,1.9-1.7c0.8-0.4,1.6-0.7,2.5-0.7s1.7,0.1,2.5,0.5 l-0.9,0.9c-0.1,0.1-0.3,0.3-0.3,0.4s0,0.4,0,0.5c0,0.1,0.1,0.3,0.3,0.4c0.3,0,0.4,0,0.7,0h4.7c0.3,0,0.4-0.1,0.5-0.3 c0.1-0.1,0.3-0.4,0.3-0.5v-4.7c0-0.1,0-0.3-0.1-0.5c-0.1-0.1-0.3-0.3-0.4-0.3s-0.3-0.1-0.5,0C54.1,46.5,53.9,46.5,53.9,46.6 L53.9,46.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.6,55.3h-1.7c-0.3,0-0.4,0.1-0.5,0.3c-0.1,0.1-0.3,0.3-0.3,0.5c-0.1,1.3-0.8,2.5-1.9,3.5 c-1.1,0.9-2.3,1.3-3.6,1.3c-0.8,0-1.6-0.1-2.4-0.5l0.9-0.9c0.1-0.1,0.1-0.3,0.3-0.4c0-0.1,0-0.4,0-0.5c0-0.1-0.1-0.3-0.3-0.4 c-0.1-0.1-0.3-0.1-0.5-0.1h-4.7c-0.3,0-0.4,0.1-0.5,0.3c-0.1,0.1-0.3,0.4-0.3,0.5v4.7c0,0.1,0,0.3,0.1,0.5c0.1,0.1,0.3,0.3,0.4,0.3 s0.3,0.1,0.5,0c0.1,0,0.3-0.1,0.4-0.3l1.3-1.3c1.5,0.9,3.2,1.5,4.9,1.5c2.1,0,4.3-0.8,6-2.3c1.6-1.5,2.7-3.5,2.9-5.7 c0-0.1,0-0.3,0-0.4s-0.1-0.3-0.1-0.3c-0.5,0-0.5,0-0.7-0.1C55.9,55.3,55.7,55.3,55.6,55.3L55.6,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39,67.1H20.5c-3.7,0-7.4,0-11.2,0C9.2,49.3,9.1,31.5,9,13.8c0-3.8,0-7.6-0.1-11.4c10.8,0,21.7-0.1,32.5-0.1 v9.4c0,2.4,0.9,4.8,2.7,6.5c1.7,1.7,4.2,2.7,6.5,2.7h9.2V45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35,63.1c0,0,0-0.1-0.1-0.1c-0.1-0.2-0.3-0.4-0.4-0.6c-1.2-1.9-2-4.1-2.3-6.3c-0.3-2.3,0-4.5,0.7-6.7 c0.8-2.1,2-4.1,3.6-5.7c0.7-0.7,1.5-1.3,2.4-1.9c0,0,0,0,0,0c0.1-0.1,0.2-0.1,0.3-0.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.8,16.4c-0.6-0.7-1.3-1.4-1.9-2.1c-2.8-2.8-5.6-5.5-8.4-8.3c-0.8-0.8-1.7-1.5-2.5-2.3V12 c0,1.1,0.5,2.2,1.2,3.1c0.9,0.9,1.9,1.2,3.1,1.2H58.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.6,20.1h-16c-1.2,0-2.3-0.8-2.3-1.6l0,0c0-0.9,1.1-1.6,2.3-1.6h16c1.2,0,2.3,0.8,2.3,1.6l0,0 C34.9,19.3,33.8,20.1,32.6,20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43,27.1H16.6c-1.2,0-2.3-0.8-2.3-1.6l0,0c0-0.9,1.1-1.6,2.3-1.6H43c1.2,0,2.3,0.8,2.3,1.6l0,0 C45.3,26.4,44.2,27.1,43,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43,34.2H16.6c-1.2,0-2.3-0.8-2.3-1.6l0,0c0-0.9,1.1-1.6,2.3-1.6H43c1.2,0,2.3,0.8,2.3,1.6l0,0 C45.3,33.4,44.2,34.2,43,34.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24,41.2h-7.5c-1.2,0-2.3-0.8-2.3-1.6l0,0c0-0.9,1.1-1.6,2.3-1.6H24c1.2,0,2.3,0.8,2.3,1.6l0,0 C26.4,40.5,25.3,41.2,24,41.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.9,63c0,0,0,0.1,0.1,0.1c1.1,1.6,2.4,2.9,4,4c2.5,1.7,5.5,2.7,8.7,2.7c8.5,0,15.4-6.9,15.4-15.4 c0-3.5-1.2-6.7-3.2-9.3c-2.8-3.7-7.2-6-12.2-6c-3.1,0-6.1,0.9-8.5,2.6c-0.1,0.1-0.2,0.1-0.3,0.2c0,0,0,0,0,0"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -43.3,
    y: 33.8,
    className: "st2",
    width: 19,
    height: 20.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -39,
    y: 64.2,
    className: "st1",
    width: 19,
    height: 20.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataupdate);
export default __webpack_public_path__ + "static/media/data update.6f29629ca5d188e25f57da9b673891b3.svg";
export { ForwardRef as ReactComponent };